import { useInternalMessagesByUuids } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/useInternalMessages";
import { useOperationalInformationTypes } from "features/CenterContent/shared/operationalInformation/hooks/useOperationalInformationTypes";
import { useTranslation } from "react-i18next";
import { InfrastructureOperationalInformationOverviewResponse } from "shared/types/operationalInformation";

export const useInfraEventCardData = (
  event: InfrastructureOperationalInformationOverviewResponse,
) => {
  const { t } = useTranslation();

  const { data: operationalInformationTypes } =
    useOperationalInformationTypes(t);

  const actionCardLabel =
    event.actionCard &&
    operationalInformationTypes?.actionCards.find(
      (it) => it.type === event.actionCard?.type,
    )?.label;

  const internalMessagesByUuid = useInternalMessagesByUuids([event.uuid]);
  const internalMessages = internalMessagesByUuid[event.uuid]?.filter(
    (message) => !message.evaluationForm,
  );

  return {
    actionCardLabel,
    internalMessages,
  };
};
